import React from 'react';
import { currentInvitationReturn } from '../../auth/authReturn';
import GoogleAuth from './GoogleAuth';
import StagingLogin from './StagingLogin';
import { features } from '../../config/features';
import { BookIcon, MicIcon, MoonIcon } from '../icons';
import './LandingPage.css';

/**
 * Signed-out landing: one greeting, one sign-in action, the protected trust
 * copy, three plain feature lines. Rendered inside the signed-out shell,
 * which carries the wordmark.
 */
const LandingPage: React.FC = () => {
  const isVoiceInvitation = Boolean(currentInvitationReturn());
  return (
    <div className="landing">
      <h1 className="landing__title">Bedtime stories in a voice they love.</h1>

      <section className="landing__auth" aria-labelledby="landing-auth-title">
        <h2 id="landing-auth-title">{isVoiceInvitation ? 'Continue your voice invitation' : 'Get started'}</h2>
        <p className="landing__lede">{isVoiceInvitation
          ? 'Use your own account to consent and record. Luma will bring you back to this invitation.'
          : 'Sign in to create your personalized voice stories'}</p>
        {features.stagingMode ? <StagingLogin /> : <GoogleAuth />}
      </section>

      <div className="landing__trust" aria-label="How family voices work">
        <p><strong>Your family stays in control.</strong></p>
        <ul>
          <li>Only authorized household adults choose a Family voice and approve playback.</li>
          <li>Voice donors consent through their private invitation before recording.</li>
          <li>Revoking voice consent stops future capture and new stories with that voice.</li>
        </ul>
      </div>

      <ul className="landing__features">
        <li>
          <span className="landing__feature-icon" aria-hidden="true"><BookIcon size={22} /></span>
          <span><strong>Personal stories</strong><span>Bedtime stories for your family.</span></span>
        </li>
        <li>
          <span className="landing__feature-icon" aria-hidden="true"><MicIcon size={22} /></span>
          <span><strong>Family voice</strong><span>Record your voice for their bedtime stories.</span></span>
        </li>
        <li>
          <span className="landing__feature-icon" aria-hidden="true"><MoonIcon size={22} /></span>
          <span><strong>Ready for bedtime</strong><span>Soothing stories designed for peaceful sleep</span></span>
        </li>
      </ul>

      <p className="landing__footer">A story from you, every night.</p>
    </div>
  );
};

export default LandingPage;
